import { CcRequirementSmartCompliance } from "server/models"
import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setCcRequirementSmartComplianceList = (complianceList: types.CcRequirementSmartComplianceList) => ({
    type: inferLiteral(types.CC_REQUIREMENT_SMART_COMPLIANCE_LIST),
    complianceList,
})
export const setCcRequirementSmartComplianceIds = (complianceIds: readonly number[]) => ({
    type: inferLiteral(types.CC_REQUIREMENT_SMART_COMPLIANCE_IDS),
    complianceIds,
})
export const setCcRequirementSmartComplianceEdit = (compliance: CcRequirementSmartCompliance) => ({
    type: inferLiteral(types.CC_REQUIREMENT_SMART_COMPLIANCE_EDIT),
    compliance,
})
export const setCcRequirementSmartComplianceSort = (sortColumn: keyof CcRequirementSmartCompliance, sortOrder: OrderType) => ({
    type: inferLiteral(types.CC_REQUIREMENT_SMART_COMPLIANCE_SORT),
    sortColumn,
    sortOrder,
})
export const setCcRequirementSmartComplianceFilters = (filters: types.CcRequirementSmartComplianceFilters) => ({
    type: inferLiteral(types.CC_REQUIREMENT_SMART_COMPLIANCE_FILTERS),
    filters,
})
export const setCcRequirementSmartComplianceReloadList = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_SMART_COMPLIANCE_RELOAD_LIST),
    value,
})
export const setCcRequirementSmartComplianceReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.CC_REQUIREMENT_SMART_COMPLIANCE_RELOAD_EDIT),
    value,
})
